import { render, staticRenderFns } from "./gateControl.vue?vue&type=template&id=d4a5bbd4&scoped=true&"
import script from "./gateControl.vue?vue&type=script&lang=js&"
export * from "./gateControl.vue?vue&type=script&lang=js&"
import style0 from "./gateControl.vue?vue&type=style&index=0&id=d4a5bbd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a5bbd4",
  null
  
)

export default component.exports